module.exports = __webpack_public_path__ + "static/img/i38.f9dc4fe2.png";